import React from 'react';

export default function TwoHobs({ color }) {
  return(
    <svg width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>two-hobs</title>
      <g id="Mobile" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Contact-Hob-Count" transform="translate(-147.000000, -203.000000)" stroke={color}>
          <g id="2-hobs" transform="translate(20.000000, 190.000000)">
            <g id="Group" transform="translate(0.000000, 14.000000)">
              <g id="two-hobs" transform="translate(128.000000, 0.000000)">
                <rect id="Rectangle" strokeWidth="2" x="0" y="0" width="24" height="24" rx="1"></rect>
                <g id="big-hob" transform="translate(2.500000, 6.333333)">
                  <line x1="0.666666667" y1="5" x2="0.666666667" y2="5.66666667" id="Line-2-Copy-2" strokeLinecap="square" transform="translate(0.666667, 5.333333) rotate(-90.000000) translate(-0.666667, -5.333333) "></line>
                  <line x1="10" y1="5" x2="10" y2="5.66666667" id="Line-2-Copy-3" strokeLinecap="square" transform="translate(10.000000, 5.333333) rotate(-90.000000) translate(-10.000000, -5.333333) "></line>
                  <line x1="5.33333333" y1="0.666666667" x2="5.33333333" y2="1.33333333" id="Line-2" strokeLinecap="square"></line>
                  <line x1="5.33333333" y1="9.33333333" x2="5.33333333" y2="10" id="Line-2-Copy" strokeLinecap="square"></line>
                  <circle id="Oval" cx="5.33333333" cy="5.33333333" r="5.33333333"></circle>
                </g>
                <g id="small-hob" transform="translate(15.333333, 8.333333)">
                  <line x1="3.33333333" y1="5.66666667" x2="3.33333333" y2="6.33333333" id="Line-2-Copy-6" strokeLinecap="square"></line>
                  <line x1="3.33333333" y1="0" x2="3.33333333" y2="0.666666667" id="Line-2-Copy-7" strokeLinecap="square"></line>
                  <line x1="6.33333333" y1="3" x2="6.33333333" y2="3.66666667" id="Line-2-Copy-4" strokeLinecap="square" transform="translate(6.333333, 3.333333) rotate(-90.000000) translate(-6.333333, -3.333333) "></line>
                  <line x1="0.5" y1="3.16666667" x2="0.5" y2="3.5" id="Line-2-Copy-5" strokeLinecap="square" transform="translate(0.500000, 3.333333) rotate(-90.000000) translate(-0.500000, -3.333333) "></line>
                  <circle id="Oval-Copy-9" cx="3.33333333" cy="3.33333333" r="3.33333333"></circle>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
